<lgd-text *ngIf="isTextField(field)" [controlName]="controlName" [label]="field.Caption" [attr.telemetry]="ariaLabel">
</lgd-text>

<lgd-select *ngIf="isSelectField(field)" [controlName]="controlName" [label]="field.Caption" [options]="optionsObservable" [attr.telemetry]="ariaLabel">
</lgd-select>

<lgd-number *ngIf="isNumberField(field)" [controlName]="controlName" [label]="field.Caption" [attr.telemetry]="ariaLabel">
</lgd-number>

<lgd-date-picker *ngIf="isDateField(field)" [controlName]="controlName" [label]="field.Caption" [attr.telemetry]="ariaLabel">
</lgd-date-picker>

<lgd-checkbox *ngIf="isCheckboxField(field)" [controlName]="controlName" [label]="field.Caption" [attr.telemetry]="ariaLabel">
</lgd-checkbox>